// Paths matched by useCurrentPath for breadcrumbs: nav items plus the detail
// screens under them, which have no navLabel but still need a header path.
// Extracted here so useCurrentPath does not import navigation.tsx, which pulls in
// feature JSX and would create a module cycle:
//   useCurrentPath → navigation → @/features/content → @/components → MainLayout → Header → useCurrentPath
export const NAV_LABEL_PATHS: { path: string; isHideOnProd?: boolean }[] = [
  { path: '/pages/instagram' },
  { path: '/pages/instagram/:id' },
  { path: '/pages/telegram' },
  { path: '/pages/telegram/:id' },
  { path: '/meta/user-data-deletion' },
  { path: '/meta/data-deletion-audit-log' },
  { path: '/profiles' },
  { path: '/profiles/:id' },
  { path: '/managers' },
  { path: '/managers/devices' },
  { path: '/chat' },
  { path: '/payments' },
  { path: '/bot-pages/telegram' },
  { path: '/prophet/meta' },
  { path: '/prophet/meta/:id' },
  { path: '/prophet/telegram' },
  { path: '/prophet/telegram/:id' },
  { path: '/prophet/keywords/meta/:id' },
  { path: '/prophet/keywords/telegram/:id' },
  { path: '/bot/allowed-users' },
  { path: '/ai/prompt-templates' },
  { path: '/analytics/managers' },
  { path: '/analytics/requests' },
  { path: '/analytics/triggers' },
  { path: '/analytics/new-dialogs' },
  { path: '/analytics/instagram' },
  { path: '/analytics/base' },
  { path: '/ai-reports', isHideOnProd: true },
  { path: '/ai-reports/prompts', isHideOnProd: true },
  { path: '/ai-reports/:reportId', isHideOnProd: true },
  { path: '/checks/traffic-sources' },
  { path: '/checks/payment-types' },
  { path: '/checks/payment-providers' },
  { path: '/checks/services' },
  { path: '/checks/goods' },
  { path: '/analytics/base' },
  { path: '/checks/device-tracker' },
  { path: '/access/accounts' },
  { path: '/access/roles' },
  { path: '/content' },
  { path: '/dictionaries' },
];
